import { Divider } from 'antd';

import { PortalOutlinedHeartIcon } from '@shared/assets-icon';
import { SITE_CORE_URL } from '@shared/constants/paths';
import { useGetHomePageTrendingArticlesQuery } from '@shared/services/sitecore';

import { HEALTH_CONDITIONS } from '../../constants';
import { mapArticles } from '../../utils';
import ArticleSection from '../ArticleSection';
import ArticleSectionCollapse from '../ArticleSectionCollapse';
import Linkout from '../Linkout';

const HealthConditions = () => {
  const { data } = useGetHomePageTrendingArticlesQuery();

  const commonHealthConditionArticles = mapArticles(data?.navigation?.healthCondition.commonHealthCondition);

  const articleSection = [
    {
      articles: commonHealthConditionArticles,
      icon: <PortalOutlinedHeartIcon className="text-white" />,
      title: 'Common Health Conditions',
    },
  ];

  return (
    <div className="flex w-full flex-col lg:flex-row lg:gap-16">
      <div className="w-full lg:w-2/5">
        <Linkout
          className="grid-cols-1 lg:grid-cols-2"
          isCollapse={false}
          links={HEALTH_CONDITIONS}
          viewAllUrl={SITE_CORE_URL.healthConditions}
        />
      </div>
      <Divider className="m-0 hidden h-full border-dashed border-primary-green-3 lg:block" type="vertical" />
      <div className="hidden flex-1 grid-cols-1 gap-6 lg:grid">
        {articleSection.map(({ articles, icon, title }) => (
          <ArticleSection articles={articles} className="lg:grid-cols-2" icon={icon} key={title} title={title} />
        ))}
      </div>
      <ArticleSectionCollapse articleSection={articleSection} className="lg:hidden" />
    </div>
  );
};

export default HealthConditions;
